import { makeImmutable } from "../core";
import { Holiday, Money, OrderingHours, OrderingPolicy, ProductInstanceParser, Restaurant, WeeklySchedule, automaticCrossSellingCategoryFilter, } from "../ordering";
import { AutomaticCrossSellingWeightsParser } from "./AutomaticCrossSellingWeightsParser";
import { CrossSellingListParser } from "./CrossSellingListParser";
import { MenuV2Parser } from "./MenuV2Parser";
import { PackagingContainerParser } from "./PackagingContainerParser";
export class RestaurantParser {
    constructor(params) {
        this.rpcService = params.rpcService;
        this.checkoutInfoService = params.checkoutInfoService;
        this.holidayService = params.holidayService;
        this.appOrigin = params.appOrigin;
        makeImmutable(this);
    }
    maxOrderValue(input) {
        const { max_order_value } = input;
        return max_order_value === null ? null : Money.fromBackend(max_order_value);
    }
    async parse({ restaurantId, input, orderingAvailability, }) {
        const onlineOrderingSettings = input.online_ordering_settings;
        const menuParser = new MenuV2Parser({
            catalogue: input.catalogue,
            appOrigin: this.appOrigin,
            onlineOrderingSettings,
        });
        const menu = menuParser.parseMenu();
        const crossSellingListParser = new CrossSellingListParser({
            catalogue: input.catalogue,
            productTypeIds: menu.productTypes.ids,
            productInstanceParser: new ProductInstanceParser({
                productCategories: menu.productCategories,
                productTypes: menu.productTypes,
                modifierTypes: menu.modifierTypes,
                customParameterTypes: menu.customParameterTypes,
            }),
        });
        const orderingPossible = orderingAvailability.tag === "OrderingPossible";
        const checkoutInfo = await this.checkoutInfoService.getCheckoutInfo(restaurantId, input.time_zone);
        const holidays = await this.holidayService
            .getHolidays(restaurantId)
            .then((infos) => infos.map((info) => Holiday.fromHolidayInfo(info, input.time_zone)));
        const paymentChannels = await this.checkoutInfoService.getPaymentChannels(restaurantId);
        const orderingHours = new OrderingHours({
            weeklySchedule: WeeklySchedule.fromWeeklyAvailability(input.ordering_hours),
        });
        const minOrderValue = {
            takeaway: Money.fromString(input.min_order_value_with_pickup),
            default: Money.fromString(input.min_order_value),
        };
        const automaticCrossSellingWeightsParser = new AutomaticCrossSellingWeightsParser({
            weights: await this.rpcService.rpc("GetAcsWeights", {
                restaurantId: restaurantId.value,
            }),
        });
        const allowedAutomaticCrossSellingProductCategories = menu.productCategories.ids.filter((productCategoryId) => automaticCrossSellingCategoryFilter(input.catalogue.categories[productCategoryId.value].name));
        const orderingPolicy = new OrderingPolicy({
            maxOrderValue: this.maxOrderValue(input),
            deliveryInTotal: input.delivery_in_total,
            enableCoupons: input.enable_coupons,
            enableFod: input.enable_fod,
            enableMarketingConsents: input.enable_marketing_consents,
        });
        const packagingContainerParser = new PackagingContainerParser({
            catalogue: input.catalogue,
        });
        return Restaurant.create({
            menu,
            id: restaurantId,
            orderingPolicy,
            orderingHours,
            holidays,
            packagingContainerTypes: packagingContainerParser.parse(),
            timezone: input.time_zone,
            appOrigin: this.appOrigin,
            orderingPossible,
            checkoutInfo,
            paymentChannels,
            onlineOrderingSettings,
            minOrderValue,
            crossSellingListRepository: crossSellingListParser.parse(),
            allowedAutomaticCrossSellingProductCategories,
            automaticCrossSellingWeights: automaticCrossSellingWeightsParser.parse(),
        });
    }
}
